import { __rest } from "tslib";
import * as React from 'react';
export var FormSelectOption = function FormSelectOption(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$value = _a.value,
      value = _a$value === void 0 ? '' : _a$value,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      label = _a.label,
      props = __rest(_a, ["className", "value", "isDisabled", "label"]);

  return React.createElement("option", Object.assign({}, props, {
    className: className,
    value: value,
    disabled: isDisabled
  }), label);
};